import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { QUERY_PARAM_KEYS, QUERY_PARAM_VALUES } from '../../constants/massOfferings/queryParamKeys';
import { useSearchParams } from '../../hooks/useSearchParams';
import selectors from '../../store/selectors';
import AddMassOffering from '../AddMassOffering/AddMassOfferingContainer';
import MassList from '../MassList/MassListContainer';
import { AfterTransaction } from '../MassOfferings';

const MassOfferingsContent = ({ inboxDictionary }) => {
  const urlSearchParams = useSearchParams();
  const massOfferingFeatureFlag = useSelector(selectors.selectMassOfferingFeatureFlag);

  const isFromTransaction =
    urlSearchParams.get(QUERY_PARAM_KEYS.source) === QUERY_PARAM_VALUES.TRANSACTION;

  if (isFromTransaction) {
    return <AfterTransaction />;
  }

  if (!massOfferingFeatureFlag) {
    return (
      <div>
        <p>Nie przyjmujemy obecnie intencji na wybrany termin poprzez formularz online.</p>
      </div>
    );
  }

  return (
    <React.Fragment>
      <AddMassOffering />
      <MassList inboxDictionary={inboxDictionary} />
    </React.Fragment>
  );
};

MassOfferingsContent.propTypes = {
  inboxDictionary: PropTypes.array,
};

export default MassOfferingsContent;
